"use client";
import { jsx as r } from "react/jsx-runtime";
import { Alert as i } from "../../alert/alert.js";
import { forwardRef as a, useRef as c, useImperativeHandle as u } from "react";
import '../../../assets/error-alert.css';const f = {
  "error-alert__button": "_error-alert__button_1bkpi_1"
}, m = (e) => {
  if (typeof e == "string") return e;
  if (e.root) return e.root.message;
  if (e.message) return e.message;
}, d = a(
  ({ errors: e, setFocus: o }, l) => {
    const n = c(null);
    return u(l, () => ({
      focus: () => {
        var t;
        (t = n.current) == null || t.focus();
      }
    })), Object.keys(e).length === 0 ? null : /* @__PURE__ */ r(i, { variant: "error", title: "You have the following error(s):", children: /* @__PURE__ */ r("div", { ref: n, tabIndex: -1, children: /* @__PURE__ */ r("ul", { children: Object.entries(e).map(([t, s]) => /* @__PURE__ */ r("li", { children: /* @__PURE__ */ r("p", { children: /* @__PURE__ */ r(
      "button",
      {
        onClick: () => o(t),
        className: f["error-alert__button"],
        children: m(s)
      }
    ) }) }, t)) }) }) });
  }
);
d.displayName = "ErrorAlert";
export {
  d as ErrorAlert
};
